import { Capacitor } from '@capacitor/core';

/** Returns true when running inside a native Capacitor shell (Android/iOS). */
export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}

/** Returns 'android' | 'ios' | 'web' */
export function getPlatform(): string {
  return Capacitor.getPlatform();
}
